import axios from 'axios'
import { Message } from 'element-ui'
import { webSignHeaders } from '@/utils/sign'

export function resolveBaseURL() {
  const env = process.env.VUE_APP_API_BASE || '/api'
  if (/https?:\/\//.test(env)) {
    if (/:(8080|8082|8081)\/api/.test(env)) return '/api'
    return env
  }
  return env
}

const request = axios.create({
  baseURL: resolveBaseURL(),
  timeout: 60000
})

request.interceptors.request.use(config => {
  Object.assign(config.headers, webSignHeaders())
  return config
})

request.interceptors.response.use(
  res => {
    const body = res.data
    if (!body || typeof body.code === 'undefined') return body
    if (body.code !== 200) {
      const msg = body.msg || '请求失败'
      Message.error(msg)
      return Promise.reject(new Error(msg))
    }
    return { code: 0, data: body.data, msg: body.msg, msgCode: body.msg_code }
  },
  err => {
    const body = err.response && err.response.data
    let msg = (body && body.msg) || err.message || '请求失败'
    if (typeof body === 'string' && body.indexOf('Cannot GET /api') >= 0) {
      msg = '接口代理未生效：请用 npm run serve 启动 client（端口 8081）'
    }
    Message.error(msg)
    return Promise.reject(new Error(msg))
  }
)

export default request
